import { render } from "./RaceRatingBlock.vue?vue&type=template&id=3963d9eb&scoped=true"
import script from "./RaceRatingBlock.vue?vue&type=script&lang=js"
export * from "./RaceRatingBlock.vue?vue&type=script&lang=js"

import "./RaceRatingBlock.vue?vue&type=style&index=0&id=3963d9eb&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3963d9eb"]])

export default __exports__